<template>
  <div class="vLoading-container">
    <div class="vLoading-main">
      <div
        class="flex-center loading-box"
        v-if="loading"
        :style="{ background: backgroundColor, color: txtColor }"
      >
        <svg
          t="1567069979438"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2399"
          :style="{ width: iconSize, height: iconSize }"
        >
          <path
            d="M538.5344 266.4448a133.12 133.12 0 1 1 133.12-133.12 133.4272 133.4272 0 0 1-133.12 133.12zM255.0144 372.1984a121.6768 121.6768 0 1 1 121.6768-121.6768 121.856 121.856 0 0 1-121.6768 121.6768zM134.72 647.424a107.3664 107.3664 0 1 1 107.3664-107.264A107.52 107.52 0 0 1 134.72 647.424z m120.32 272.4608a90.9824 90.9824 0 1 1 90.9824-90.9824A91.1616 91.1616 0 0 1 255.04 919.8848zM538.5344 1024a79.36 79.36 0 1 1 79.36-79.36 79.36 79.36 0 0 1-79.36 79.36z m287.6928-134.144a64.1792 64.1792 0 1 1 64.1792-64.1792 64.3584 64.3584 0 0 1-64.1792 64.1792z m117.76-296.704a52.6336 52.6336 0 1 1 52.6592-52.6336 52.608 52.608 0 0 1-52.6336 52.6336z m-158.72-338.7136a40.96 40.96 0 1 1 12.0064 28.8512 40.5248 40.5248 0 0 1-12.0064-28.8512z"
            :fill="txtColor"
            p-id="2400"
          />
        </svg>
        <div class="loading-txt">{{ loadingTxt }}</div>
      </div>
      <div
        class="flex-center loading-box loading-node"
        :style="{ background: backgroundColor, color: txtColor }"
        v-if="!loading && isHaveData"
      >
        暂无数据
      </div>
      <div ref="dEc" class="demo-ec" />
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
//  this.$refs.echarts.showLoading();//loading展示
// this.$refs.echarts.noOption();//隐藏loading
// this.$refs.echarts.hideData();//暂无数据
// this.$refs.echarts.setOptions(this.options); //赋值数据
export default {
  name: "vLoading",
  props: {
    loadingTxt: {
      type: String,
      default: "数据加载中...",
    },
    backgroundColor: {
      type: String,
      default: "rgba(1, 30, 47, .5)",
    },
    txtColor: {
      type: String,
      default: "#fff",
    },
    iconSize: {
      type: String,
      default: "28px",
    },
  },
  data() {
    return {
      myEchart: null,
      loading: true,
      isHaveData: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.myEchart = echarts.init(this.$refs.dEc);
      window.addEventListener("resize", this.chartResize);
    });
  },
  methods: {
    // 实时更新echart图
    chartResize() {
      this.myEchart && this.myEchart.resize();
    },
    // 展示加载中
    showLoading() {
      this.clearEChart();
      this.loading = true;
      this.isHaveData = false;
    },
    // 隐藏加载 展示数据
    setOptions(option) {
      this.clearEChart();
      if (
        this.myEchart &&
        option.series &&
        option.series.length > 0 &&
        option.series[0].data &&
        option.series[0].data.length > 0
      ) {
        this.myEchart.setOption(option);
        this.loading = false;
        this.isHaveData = false;
        return;
      }
      this.loading = false;
      this.isHaveData = true;
    },
    noOption() {
      this.clearEChart();
      this.loading = false;
      this.isHaveData = true;
    },
    clearEChart() {
      this.myEchart && this.myEchart.clear();
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.chartResize);
  },
};
</script>

<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.vLoading-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.vLoading-main {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.vLoading-main .loading-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
  z-index: 100;
}
.vLoading-main .demo-ec {
  width: 100%;
  height: 100%;
}
.vLoading-main .demo-ec div {
  width: 100% !important;
  height: 100% !important;
}
.loading-txt {
  margin: 3px 0;
  font-size: 14px;
}
.loading-node {
  font-size: 16px;
}
.vLoading-main .icon {
  animation: load 1.2s linear infinite;
}
@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
